import { Question } from 'types'
import { FillBlankEditor } from 'lesson-builder/question-types/fill-blank'
import { MultipleChoiceEditor } from 'lesson-builder/question-types/multiple-choice'
import { ShortAnswerEditor } from 'lesson-builder/question-types/short-answer'

/**
 * @module lesson-builder/components/question-editor
 * @description Dispatches to the right per-type editor for a question
 * being edited. See
 * docs/BLUEPRINT-2026-10-01-question-slide-decomposition.md.
 */
const QUESTION_EDITORS = {
	'fill-blank': FillBlankEditor,
	'multiple-choice': MultipleChoiceEditor,
	'short-answer': ShortAnswerEditor
} as const;

export const QuestionEditor = ({ question, setShowFeedback, onEdit, setIsEditing }: { question: Question, setShowFeedback: (showFeedback: boolean) => void, onEdit: (payload: Partial<Question>) => void, setIsEditing: (isEditing: boolean) => void }) => {
    const QuestionEditorComponent: React.FC<{ setIsEditing: (isEditing: boolean) => void, onEdit: (payload: Partial<Question>) => void, question: Question, setShowFeedback?: (showFeedback: boolean) => void }> = QUESTION_EDITORS[question.type]

	// Type-safe wrapper for onEdit
	const handleEdit = (payload: Partial<Question>) => {
		onEdit(payload)
	}

	return (
		<>
			<div className="question-editor">
                <QuestionEditorComponent
                    setIsEditing={setIsEditing}
                    onEdit={handleEdit}
                    question={question}
                    setShowFeedback={setShowFeedback}
                />
			</div>
		</>
	)
}

export default QuestionEditor
